import React, { FC } from 'react';
import { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { User } from '@lib/graphql/generated';

export interface AuthorLineProps extends PropsWithClassProps<'authorLine' | 'names'> {
  authors: User[];
}

export const AuthorLine: FC<AuthorLineProps> = ({ classProps, authors }) => {
  return (
    <p className={classProps?.authorLine}>
      von&nbsp;
      <span className={classProps?.names}>
        {authors?.map((author, index) => (
          <span key={index}>
            {author.name}
            {index < authors.length - 2 ? ', ' : index < authors.length - 1 ? ' & ' : ''}
          </span>
        ))}
      </span>
    </p>
  );
};
